// 采销工作台 — Vuex 模块
import { FILTER_TABS, VIEW_TABS } from '~/pages/work-board/constants'
import { mockCtxList, mockProcureItems, mockSalesLines, mockAutoMatch, mockOrderTasks, mockPoolItems, mockMessages } from '~/pages/work-board/mock/data'

const state = {
  curView: 'sales',
  ctxFilter: null,
  searchQuery: '',
  accordionState: {},
  // 筛选器
  salesFltrCust: '',
  salesFltrMdl: '',
  salesFltrBrd: '',
  salesFltrBuyer: '',
  // 第一阶段：Mock 数据
  ctxList: [...mockCtxList],
  procureItems: [...mockProcureItems],
  salesLines: JSON.parse(JSON.stringify(mockSalesLines)),
  autoMatch: JSON.parse(JSON.stringify(mockAutoMatch)),
  orderTasks: [...mockOrderTasks],
  poolItems: [...mockPoolItems],
  messages: [...mockMessages]
}

const getters = {
  // 当前视图下的数据
  viewData: (state) => {
    if (state.curView === 'sales' || state.curView === 'manager') {
      return state.ctxList
    }
    if (state.curView === 'procure') {
      return state.procureItems
    }
    return []
  },
  // 筛选后的列表
  filteredList: (state) => {
    let list = []
    if (state.curView === 'sales' || state.curView === 'manager') {
      list = state.ctxFilter
        ? state.ctxList.filter(c => c.status === state.ctxFilter)
        : [...state.ctxList]
      // 销售视图权限过滤
      // 第二阶段：通过 shop_member_id 过滤
    } else if (state.curView === 'procure') {
      list = [...state.procureItems]
    }
    // 搜索过滤
    if (state.searchQuery) {
      const q = state.searchQuery.toLowerCase()
      list = list.filter(item => {
        const ctx = item
        return (ctx.customer || '').toLowerCase().includes(q) ||
          (ctx.id || '').toLowerCase().includes(q) ||
          (ctx.title || '').toLowerCase().includes(q) ||
          (ctx.sales || '').toLowerCase().includes(q)
      })
    }
    return list
  },
  // 各状态计数
  stats: (state) => {
    const counts = {}
    FILTER_TABS.forEach(tab => {
      if (tab.key === null) {
        counts['all'] = state.ctxList.length
      } else {
        counts[tab.key] = state.ctxList.filter(c => c.status === tab.key).length
      }
    })
    // 全局报价行/总行
    let quoted = 0
    let total = 0
    Object.values(state.salesLines).forEach(sl => {
      quoted += sl.quoted || 0
      total += sl.total || 0
    })
    counts.quotedLines = quoted
    counts.totalLines = total
    return counts
  }
}

const mutations = {
  SET_VIEW(state, view) {
    state.curView = view
  },
  SET_FILTER(state, filter) {
    state.ctxFilter = filter
  },
  SET_SEARCH(state, query) {
    state.searchQuery = query
  },
  TOGGLE_CARD(state, ctxId) {
    state.accordionState = {
      ...state.accordionState,
      [ctxId]: !state.accordionState[ctxId]
    }
  },
  EXPAND_ALL(state, ctxIds) {
    const newState = { ...state.accordionState }
    ctxIds.forEach(id => { newState[id] = true })
    state.accordionState = newState
  },
  COLLAPSE_ALL(state) {
    state.accordionState = {}
  },
  SET_SALES_FILTER(state, { key, value }) {
    state[key] = value
  },
  RESET_SALES_FILTERS(state) {
    state.salesFltrCust = ''
    state.salesFltrMdl = ''
    state.salesFltrBrd = ''
    state.salesFltrBuyer = ''
  },
  // 第二阶段用：替换为真实数据
  SET_CTX_LIST(state, list) {
    state.ctxList = list
  },
  SET_PROCURE_ITEMS(state, list) {
    state.procureItems = list
  }
}

const actions = {
  switchView({ commit }, view) {
    commit('SET_VIEW', view)
    commit('SET_FILTER', null)
    commit('COLLAPSE_ALL')
    commit('RESET_SALES_FILTERS')
  },
  setFilter({ commit }, filter) {
    commit('SET_FILTER', filter)
  },
  setSearch({ commit }, query) {
    commit('SET_SEARCH', query)
  },
  toggleCard({ commit }, ctxId) {
    commit('TOGGLE_CARD', ctxId)
  },
  expandAll({ commit, getters }) {
    const ids = getters.filteredList.map(c => c.id)
    commit('EXPAND_ALL', ids.slice(0, 5)) // 最多展开5张
  },
  collapseAll({ commit }) {
    commit('COLLAPSE_ALL')
  },
  // 第二阶段：异步加载（需在文件顶部 import axios from '~/common/plugins/axios.js'）
  async fetchTaskList({ commit, rootState }) {
    // const shopMemberId = rootState.login?.userProfile?.shop_member_id
    // const { code, data } = await axios.('/rest/store/biz/v3/rfq/search', {
    //   current: 1, page_size: 30, shop_member_id: shopMemberId
    // })
    // if (code === 200 && data?.list) commit('SET_CTX_LIST', data.list)
  },
  async fetchTaskDetail({ commit }, ctxId) {
    // 第二阶段：GET /rfq/{id}/detail 聚合接口
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
